import { createFileRoute } from '@tanstack/react-router';
import { BanksPage } from '@/features/accounting/parameters/banks/BanksPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/parameters/banks')({
  component: BanksPage,
});
